import Cookie from 'js-cookie';

import { lang } from '@ott/l10n';
import { getCurrency } from '@ott/money';

import { PRODUCTS } from '../constants';

export const getQueryByProduct = (
  product,
  from = 'MOW',
  referrer,
  currency,
  locale,
  limit = 50
) => {
  const source = referrer || Cookie.get('referrer');
  const [language, langLocale = language] = lang.split('-');

  switch (product) {
    case PRODUCTS.hotels: {
      return {
        lang: language,
        locale: locale || langLocale,
        currency: currency || getCurrency(lang),
        limit: limit,
        target: 'site',
      };
    }
    case PRODUCTS.avia:
      return {
        locale: langLocale,
        deals_limit: 50,
        origin: from,
        source,
        noPricing: true,
        add_locale_top: true,
      };
    default:
      return null;
  }
};
